import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetAdditionalCoverageUrl,
	GetAdditionalCoverageUrlModel,
} from 'domain/usecases/private/external-links/additional-coverage';

export class RemoteGetAdditionalCoverage implements GetAdditionalCoverageUrl {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAdditionalCoverageUrlModel>,
	) {}

	async get(): Promise<GetAdditionalCoverageUrlModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
